<template>
  <div class="invoice-com-wrap" :title="text">
    <span :class="{'red': rowData.invoice_status === 2}">{{text}}</span>
    <Tooltip
      v-if="Number(rowData.invoice_status) === 2"
      :transfer="true"
      :content="rowData.apply_check_info.check_text || '暂无数据'"
      placement="top" max-width="158"
    >
      <i class='iconfont iconwenhao yjh-active'></i>
    </Tooltip>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    rowData: Object,
    index: Number
  },
  computed: {
    routeType() {
      return this.$route.name
    },
    text() {
      return Number(this.rowData.invoice_status) === 2 ? '发票驳回' : '发票已寄出'
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.invoice-com-wrap {
  // color: $blue;
}
.iconwenhao {
  margin-left: 5px;
  color: #CBD7DC;
}
</style>
<style lang="scss">
@import '@/styles/color.scss';
.ivu-tooltip-inner {
  background-color: $white !important;
  color: $black;
  font-size: 12px;
  word-break: break-all;
}
.ivu-tooltip-popper[x-placement^=top] .ivu-tooltip-arrow {
  border-top-color: $white;
}
</style>
